// extracted by mini-css-extract-plugin
module.exports = {"copyright-notice":"CopyrightNotice_copyright-notice__3EYpY"};